import { EDEditor } from '../lib/ed/editor';
import { EDFields } from '../lib/ed/fields';
import { EDI18NInput } from '../lib/ed/input';
import { EDSection } from '../lib/ed/section';
import { MContext, mTemplateFieldsForContext } from '../lib/mdl/m-template';
import { UILabeled } from '../lib/ui/component/labeled';
import { UISelect } from '../lib/ui/component/select';
import { $el } from '../lib/ui/elements';
import { UIClassesSpec } from '../lib/ui/types';
import { YForm, $form } from '../lib/y/form';
import { YLanguage } from '../lib/y/i18n';

export class AdminPushEditor extends EDEditor<any, any> {
    form: YForm;

    constructor(context: MContext, name: string, languages: YLanguage[], classes?: UIClassesSpec) {
        const [fields, link_values] = mTemplateFieldsForContext(context);

        super(new EDFields(fields), [], [], name, languages, classes);

        const title = new EDI18NInput({ fields: this.fields, classes: 'r-title', placeholder: 'Title' });
        const body = new EDI18NInput({ fields: this.fields, classes: 'r-body', placeholder: 'Body' })
        const link = new UISelect(link_values);

        this.form = $form({ title, body, link });

        this.properties = $el.DIV('l-form', [
            new UILabeled(link, { above: 'Link' }),
        ]);

        this.content.ui_prepend($el.DIV('tl-push-box', [
            $el.DIV('r-top', [$el.DIV('r-logo'), $el.I("Abundo")]),
            title,
            body
        ]));

        this.content.addEventListener('click', e => {
            this.selectObject(this);
            e.stopPropagation();
        });
    }

    protected override makeSection(): EDSection<any, any> {
        return undefined as any;
    }

    protected override newSection(): never {
        throw 'Not implemented';
    }
}